import { Component, computed, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ILessonListItem } from '@lb/api/mylb/interfaces';
import { LessonCardV2Component, ILessonCardSurvey } from '@lb/components/lesson-card-v2/lesson-card-v2.component';
import { EnrollmentStateService } from '@lb/state/enrollment-state.service';
import { isSurveyAvailable } from '@lb/components/lessons/utils/survey-window.util';

@Component({
	selector: 'lrnr-lesson-card',
	standalone: true,
	imports: [LessonCardV2Component],
	template: `
		<lb-lesson-card-v2
			[lesson]="lesson()"
			[lessonNumber]="lessonNumber()"
			userView="learner"
			displayedUser="instructor"
			[highlight]="highlight()"
			[isScrollActive]="isScrollActive()"
			[surveys]="surveys()"
			(cardClick)="onCardClick($event)"
			(dataChanged)="dataChanged.emit()"
		></lb-lesson-card-v2>
	`
})
export class LearnerLessonCardComponent {
	lesson = input.required<ILessonListItem>();
	lessonNumber = input<number | null>(null);
	highlight = input<'current' | 'none'>('none');
	isScrollActive = input<boolean>(false);

	dataChanged = output<void>();

	private _router = inject(Router);
	private _enrollmentState = inject(EnrollmentStateService);

	surveys = computed<ILessonCardSurvey[]>(() => {
		const semesterLessonTypeID = this.lesson().semesterLessonTypeID;
		if (!semesterLessonTypeID) return [];
		return this._enrollmentState
			.gradingTemplateSurveys()
			.filter((s) => s.semesterLessonTypeID === semesterLessonTypeID)
			.map((s) => ({
				surveyID: s.surveyID,
				surveyName: s.surveyName,
				isSubmitted: false,
				isAvailable: isSurveyAvailable(this.lesson(), s),
				canSubmit: s.respondentType === 1,
				surveyResponseID: null,
				surveyDetail: s
			}));
	});

	// Every host of this wrapper (Home, the Lessons page) sits outside any one enrollment, so the card
	// opens the lesson-context page. Enrollment-context lists render lb-lesson-card-v2 directly.
	onCardClick(lessonID: number): void {
		this._router.navigate(['/lessons', lessonID]);
	}
}
